<template>
  <div
    style="display: flex; flex-direction: row;"
  >
    <span class="progress-value"><strong>{{ chars }}</strong>/{{ maxChars !== 0 ? maxChars : 160 }}</span>
    <div 
      class="circular-progress"
      :style="{background: `conic-gradient(#7B7E7E ${progress * 3.6}deg, #ededed 0deg)`}"
    >
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProgressCircle',
  props: {
    chars: {
      type: Number,
      default: 0
    },
    maxChars: {
      type: Number,
      default: 160
    }
  },
  computed: {
    progress() {
      let chars = this.chars;
      
      if (this.maxChars === 0) {
        return 0;
      }
      
      return (chars / this.maxChars) * 100;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.circular-progress{
    position: relative;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background: conic-gradient($deepgrey 3.6deg, #ededed 0deg);
    display: flex;
    align-items: center;
    justify-content: center;
}
.circular-progress::before{
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #fff;
}
.progress-value{
    position: relative;
    font-size: 1em;
    font-weight: 500;
    margin: auto 0.5em auto 0;
    color: $deepgrey;
}
</style>